import { useQuery } from 'react-query'

import {
  fetchFilterOptionsV2,
  useFilterService,
} from 'features/filters/service'
import type { FilterOption } from 'features/filters/types'

/**
 * Fetch the project's filter options — the alias + values lookup that
 * `formatCriterionExpanded` uses to resolve UUID filter values (project /
 * theme / dataset) to pretty names in AgentInfoCard chips (Trap #3).
 *
 * Shared by the Issue Agent detail Container and the Benchmarking Agent
 * detail page — both render the same AgentInfoCard primitive.
 */
export function useFilterOptions(
  filterService: ReturnType<typeof useFilterService>,
  projectId: string | null,
): { filterOptions: FilterOption[] | undefined } {
  const { data: filterOptions } = useQuery<FilterOption[]>({
    queryKey: ['filter-options', projectId],
    queryFn: async () => {
      if (!projectId) return []
      return fetchFilterOptionsV2(projectId, null, filterService)
    },
    enabled: !!projectId,
    refetchOnWindowFocus: false,
    staleTime: 300000,
  })
  return { filterOptions }
}
